import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { message } from "antd";
import { BeneficiaryEditForm } from "../../OrderForms/BeneficiaryEditForm";
import { getCustomerDetail, updateCustomerBeneficiary, type CustomerDTO, type BeneficiaryVO } from "@ifa/utils";

export function BeneficiaryEdit() {
  const { customerId, beneficiaryId } = useParams<{ customerId: string; beneficiaryId: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [customer, setCustomer] = useState<CustomerDTO | null>(null);
  const [beneficiary, setBeneficiary] = useState<BeneficiaryVO | null>(null);

  // 添加调试日志
  useEffect(() => {
    console.log("BeneficiaryEdit - location.state:", location.state);
  }, [location.state]);

  useEffect(() => {
    if (!customerId || !beneficiaryId) {
      message.error("缺少必要參數");
      navigate(-1);
      return;
    }

    setLoading(true);
    getCustomerDetail(customerId)
      .then((res) => {
        setCustomer(res);
        // Find the beneficiary to edit
        const foundBeneficiary = res.beneficiaries?.find((b) => b.beneficiaryId === Number(beneficiaryId));
        if (foundBeneficiary) {
          setBeneficiary(foundBeneficiary);
        } else {
          message.error("找不到該受益人資料");
          navigate(-1);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch customer detail:", err);
        message.error("獲取客戶資料失敗");
        navigate(-1);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [customerId, beneficiaryId, navigate]);

  const handleSave = async (data: BeneficiaryVO) => {
    if (!customerId || !beneficiaryId) return;

    try {
      await updateCustomerBeneficiary(Number(customerId), Number(beneficiaryId), data);
      message.success("儲存成功");
      // Return to customer detail page or list
      const { from, customerId: stateCustomerId, viewMode } = (location.state as any) || {};
      if (from === "customer-list" && stateCustomerId) {
        navigate("/customers", {
          state: {
            selectedCustomerId: Number(stateCustomerId),
            viewMode: viewMode || "beneficiary",
          },
        });
      } else {
        navigate(`/customers/${customerId}`);
      }
    } catch (error) {
      console.error("Failed to update beneficiary:", error);
      // Error handled by global error handler
    }
  };

  const handleCancel = () => {
    const { from, customerId: stateCustomerId, viewMode } = (location.state as any) || {};

    // 如果是从客户列表进入,返回到客户列表并保持状态
    if (from === "customer-list" && stateCustomerId) {
      navigate("/customers", {
        state: {
          selectedCustomerId: Number(stateCustomerId),
          viewMode: viewMode || "beneficiary", // 默认返回到受益人视图
        },
      });
    } else {
      // 默认返回到客户详情页
      navigate(`/customers/${customerId}`);
    }
  };

  // if (loading) {
  //   return <Spin size="large" tip="加載中..." fullscreen />;
  // }

  if (!beneficiary || !customer) {
    return null;
  }

  return (
    <BeneficiaryEditForm
      initialData={beneficiary}
      onSave={handleSave}
      onCancel={handleCancel}
      existingBeneficiaries={customer.beneficiaries || []}
      isEdit={true}
      readOnly={false}
      policyholder={customer.policyholder}
    />
  );
}
